import { render, staticRenderFns } from "./AssistantCatHomePage.vue?vue&type=template&id=f2a8b82c&scoped=true"
import script from "./AssistantCatHomePage.vue?vue&type=script&lang=ts"
export * from "./AssistantCatHomePage.vue?vue&type=script&lang=ts"
import style0 from "./AssistantCatHomePage.vue?vue&type=style&index=0&id=f2a8b82c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2a8b82c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f2a8b82c')) {
      api.createRecord('f2a8b82c', component.options)
    } else {
      api.reload('f2a8b82c', component.options)
    }
    module.hot.accept("./AssistantCatHomePage.vue?vue&type=template&id=f2a8b82c&scoped=true", function () {
      api.rerender('f2a8b82c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/AssistantCatHomePage.vue"
export default component.exports